<script>
import Translatable from '@src/mixins/translatable.js'
import Resizable from '@src/mixins/resizable.js'
import SanitizerMixin from '@src/mixins/sanitizer-mixin.js'

export default {
  mixins: [
    Translatable,
    Resizable,
    SanitizerMixin
  ],
  props: {
    news: {
      type: Object,
      required: true
    }
  },
  computed: {
    backgroundImage() {
      const img = this.news.images ? this.news.images[0] : ''
      return {
        backgroundImage: `url(${process.env.VUE_APP_STATIC_URL}small_${img})`
      }
    },
    truncationLimit() {
      return this.desktopScreen ? 620 : 210
    }
  },
}
</script>

<template>
  <div class="card-container">
    <div class="news-image" :style="backgroundImage">
      <div class="news-date">
        {{ news.datePublished | ddmmYYYY }}
      </div>
    </div>
    <div class="news-content">
      <router-link class="link"
        :to="{
         name: 'articlePage',
          params: {
            articleUrl: news.url,
          },
        }"
      >
        <h4 class="news-title">
          {{ getTranslatedContent('title', news.content) }}
        </h4>
      </router-link>
      <p
        class="news-text"
        :inner-html.prop="description(news.content) | truncate(truncationLimit)">
      </p>
      <router-link class="link"
        :to="{
          name: 'articlePage',
          params: {
            articleUrl: news.url,
          },
        }"
      >
        <p class="read-more">
          {{ getTranslatedContent('READ_MORE') }}
        </p>
      </router-link>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.news-content {
  min-height: 350px;
  height: auto;
}

.news-image {
  display: flex;
  height: 350px;
  background: $dark-gray;
  justify-content: flex-end;
  align-items: flex-end;
  border-radius: 10px;
  border: none;
  background-size: cover;
  background-position: center;
}

.news-date {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90px;
  height: 27px;
  background: $gray;
  border-radius: 10px 0;

  font-family: Open Sans Semibold, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #FFFFFF;
}

h4.news-title {
  font-family: Open Sans Bold, sans-serif; //temp-text
  font-weight: bold;
  // font-family: Open Sans, sans-serif;
  // font-weight: normal;
  font-style: normal;
  font-size: 18px;
  line-height: 23px;
  // margin-top: 24px;
  text-transform: uppercase;
  color: $dark-blue;

  &:hover {
    color: $gray;
  }
}

::v-deep .news-text {
  margin-top: 15px;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  // color: rgb(37, 37, 39, 0.8);
  color: $dark-blue;
  user-select: none;

  & em {
    font-style: italic;
  }

  & ul {
    margin-left: 20px;
    list-style: initial;
  }

  & strong {
    font-family: Open Sans Bold, sans-serif;
    font-style: normal;
    font-weight: bold;
  }

  & a {
    color: $gray;
    text-decoration: none;

    &:hover {
      color: $orange;
    }
  }

  & .ql-align-center {
    text-align: center;
  }
}

.read-more {
  cursor: pointer;
  margin-top: 25px;
  text-decoration: underline;
  text-transform: capitalize;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: $orange;
}

.read-more:hover {
  text-decoration: none;
  color: $hover-orange;
}

.card-container {
  display: grid;
  column-gap: 20px;
  width: 100%;
  height: auto;
  grid-template-columns: repeat(2, 1fr);
}

.link {
  text-decoration: none;
}

$height-to-width-ratio: 0.625;
@media only screen and (min-width: $mobile-screen-width) {
  .card-container:nth-child(2n) {
    .news-content {
      order: 1;
    }
    .news-image {
      order: 2;
    }
  }
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $container-width-xs) {

  .card-container {
    grid-template-columns: repeat(1, 1fr);
  }

  .card-container:nth-child(1n) {
    .news-content {
      order: 2;
    }
    .news-image {
      order: 1;
    }
  }

  h4.news-title {
    margin-top: 22px;
  }

  .news-image {
    border-radius: 0;
    height: 261px;
  }

  .news-date {
    border-radius: 10px 0 0 0;
  }

  .news-content {
    padding-left: 8px;
    padding-right: 8px;
    min-height: auto;
  }

  h4.article-title {
    font-size: 16px;
    line-height: 21px;
    margin-top: 22px;
  }
}
</style>
